import { useState, useEffect } from "react"

import { IDVerificationStatus } from "@lib/clients/nelo-api-client"
import { neloApiClient } from "@lib/config-client"

export const useCheckIdentityVerification = (isInitialized: boolean, isAuthenticated: boolean) => {
  const [identityVerificationStatus, setIdentityVerificationStatus] = useState<IDVerificationStatus | null>(null)

  useEffect(() => {
    if (!isInitialized || !isAuthenticated) return

    const intervalRef = { current: null as NodeJS.Timeout | null }

    const checkIdentityVerificationStatus = async () => {
      try {
        const status = await neloApiClient.checkIdentityVerificationStatus()
        setIdentityVerificationStatus(status.verificationStatus)

        if (status.verificationStatus === IDVerificationStatus.VERIFIED && intervalRef.current) {
          clearInterval(intervalRef.current)
        }
      } catch (error) {
        console.error("Error checking identity verification status:", error)
      }
    }

    checkIdentityVerificationStatus()

    intervalRef.current = setInterval(checkIdentityVerificationStatus, 5000)

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [isInitialized, isAuthenticated])

  return identityVerificationStatus
}
